import {
  Box,
  Grid,
  Typography,
  Link,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import SocialIcons from "./SocialIcons";

const LandingFooter = () => {
  const theme = useTheme();
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        p: 4,
        mt: 6,
      }}
    >
      <Grid container spacing={4}>
        {/* Left side - Map */}
        <Grid item xs={12} md={4}>
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Box
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 3,
                height: 200,
              }}
            >
              <iframe
                title="footer-map-thubarahalli-whitefield"
                src="https://www.google.com/maps?q=12.950164,77.721986&z=15&output=embed"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
            </Box>
          </motion.div>
        </Grid>

        {/* Right side - Links and Info */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={4}>
            {/* Quick Links */}
            <Grid item xs={12} sm={4}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                <Typography variant="h6" gutterBottom>
                  Quick Links
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Link href="/" underline="hover" color="inherit">
                    Home
                  </Link>
                  <Link href="/OurVision" underline="hover" color="inherit">
                    About
                  </Link>
                  <Link href="/Services" underline="hover" color="inherit">
                    Services
                  </Link>
                  <Link href="/Contactus" underline="hover" color="inherit">
                    Contact
                  </Link>

                  {/* Razorpay Required Pages */}
                  <Link href="/terms" underline="hover" color="inherit">
                    Terms & Conditions
                  </Link>
                  <Link href="/privacy" underline="hover" color="inherit">
                    Privacy Policy
                  </Link>
                  <Link href="/refund-policy" underline="hover" color="inherit">
                    Refund & Cancellation Policy
                  </Link>
                </Box>
              </motion.div>
            </Grid>

            {/* Contact Info */}
            <Grid item xs={12} sm={4}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <Typography variant="h6" gutterBottom>
                  Contact
                </Typography>
                <Typography sx={{ color: "white" }} variant="body2">
                  Address:Thubarahalli, Whitefield, Bangalore, India
                </Typography>
                <Typography sx={{ color: "white" }} variant="body2">
                 Phone: +91-9452701180
                </Typography>
                <Typography sx={{ color: "white" }} variant="body2">
                  Email: info@f-ai.in
                </Typography>
              </motion.div>
            </Grid>

            {/* Social Media */}
            <Grid item xs={12} sm={4}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <Typography variant="h6" gutterBottom>
                  Follow Us
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <SocialIcons />
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Bottom Copyright */}
      <Box
        sx={{ textAlign: "center", mt: 4, borderTop: `1px solid white`, pt: 2 }}
      >
        <Typography variant="body2" sx={{ color: "white" }}>
          © {new Date().getFullYear()} f-ai. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default LandingFooter;

